import produce from 'immer';

export const baseStats = () => ({
  highlightHistory: {
    isFetching: false,
    data: {
      bestCampaign: {},
    },
    error: null,
  },
  statsByTime: {
    isFetching: false,
    data: [],
    error: null,
  },
  history: [],
  dataMessageStats: [],
  stats: {},
  isFetching: true,
  isFetchingMessageStats: false,
  isFetchedMessageStats: false,

  errorMessageStats: null,
  errorGetStats: null,
});

//* Get message stats
export const fetchMessageStats = (actions, state) => {
  return produce(state, (draft) => {
    draft.isFetchingMessageStats = true;
    draft.isFetchedMessageStats = false;
  });
};

export const fetchMessageStatsSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.dataMessageStats = actions.data;
    draft.isFetchingMessageStats = false;
    draft.isFetchedMessageStats = true;
    draft.errorMessageStats = null;
  });
};

export const fetchMessageStatsFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.errorMessageStats = actions.error;
    draft.isFetchingMessageStats = false;
    draft.isFetchedMessageStats = false;
  });
};

//* Get stats
export const fetchStats = (actions, state) => {
  return produce(state, (draft) => {
    draft.isFetching = true;
  });
};

export const fetchStatsSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.isFetching = false;
    draft.stats = actions.stats;
    draft.history = actions.history;
  });
};

export const fetchStatsFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.errorGetStats = actions.error;
    draft.isFetching = false;
  });
};

//* Get best hist
export const fetchHighlightHistory = (actions, state) => {
  return produce(state, (draft) => {
    draft.highlightHistory.isFetching = true;
  });
};

export const fetchHighlightHistorySuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.highlightHistory.data = actions.payload;
    draft.highlightHistory.isFetching = false;
  });
};

export const fetchHighlightHistoryFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.highlightHistory.error = actions.error;
    draft.highlightHistory.isFetching = false;
  });
};

//* Get stats by time
export const fetchStatsByTime = (actions, state) => {
  return produce(state, (draft) => {
    draft.statsByTime.isFetching = true;
  });
};

export const fetchStatsByTimeSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.statsByTime.isFetching = false;
    draft.statsByTime.data = actions.data;
  });
};

export const fetchStatsByTimeFailed = (actions, state) => {
  const { error } = actions;
  return produce(state, (draft) => {
    draft.statsByTime.error = error;
  });
};
